import SpacerComponent from './SpacerComponent'
export default SpacerComponent
